<div class="policy-container" dir="rtl">
  <h3>سياسة <span>الخصوصية</span></h3>
  <p>
    <b>تاريخ السريان: 3/7/2025</b>
    <br /><br />
    تلتزم شركة <b>البرشامة</b> بحماية خصوصيتك. توضح سياسة الخصوصية هذه كيفية جمع معلوماتك واستخدامها والإفصاح عنها
    وحفظها عند زيارتك لموقعنا https://el-bershama.com، أو استخدامك لخدماتنا، أو تواصلك معنا بأي طريقة أخرى. يُرجى قراءة
    هذه السياسة بعناية لفهم آرائنا وممارساتنا المتعلقة ببياناتك الشخصية وكيفية التعامل معها.
    <br /><br />

    <b>1. المعلومات التي نجمعها</b>
    <br />
    قد نجمع الأنواع التالية من المعلومات ونعالجها:
    <br /><br />

    أ. المعلومات الشخصية:
    <br />
    الاسم <br />
    البريد الإلكتروني <br />
    رقم الهاتف <br />
    <br />

    ب. معلومات الاستخدام:
    <br />
    معلومات حول زيارتك، بما في ذلك عناوين URL الكاملة، ومسار النقر إلى موقعنا وعبره ومنه (بما في ذلك التاريخ والوقت)،
    والمنتجات/الخدمات التي عرضتها أو بحثت عنها، وأوقات استجابة الصفحات، وأخطاء التنزيل، ومدة الزيارات لصفحات معينة،
    ومعلومات تفاعل الصفحة (مثل التمرير والنقر وتحريك الماوس).
    <br /><br />

    ج. بيانات التسويق والاتصالات:
    <br />
    تفضيلاتك في تلقي المواد التسويقية منا وتفضيلات التواصل الخاصة بك.
    <br /><br />

    <b>2. كيفية استخدام معلوماتك</b>
    <br />
    نستخدم المعلومات التي نجمعها بالطرق التالية:
    <br /><br />

    أ. لتقديم خدماتنا وتحسينها:
    <br />
    لتقديم خدماتنا، بما في ذلك استشارات تكنولوجيا المعلومات، والتسويق الرقمي، وتطوير المواقع والتطبيقات، وإدارة وسائل
    التواصل الاجتماعي، والإعلانات. ولمعالجة طلباتك وأوامرك.
    <br /><br />

    ب. للتسويق والتواصل:
    <br />
    لإرسال المواد الترويجية والتحديثات المتعلقة بخدماتنا. والتواصل معك بشأن التغييرات في خدماتنا وسياساتنا وغيرها من
    المعلومات الإدارية.
    <br /><br />

    ج. للتحليل والتخصيص:
    <br />
    لفهم كيفية استخدامك لموقعنا وخدماتنا وتخصيص تجربتك. وقياس فعالية إعلاناتنا.
    <br /><br />

    د. للأمن والامتثال:
    <br />
    لحماية موقعنا الإلكتروني وموظفينا وعملياتنا التجارية. والامتثال للالتزامات القانونية وحل النزاعات وتطبيق اتفاقياتنا.
    <br /><br />

    <b>3. مشاركة معلوماتك</b>
    <br />
    لا نبيع معلوماتك الشخصية أو نتاجر بها أو ننقلها إلى أطراف خارجية إلا كما هو موضح أدناه:
    <br /><br />

    أ. مزودو الخدمات:
    <br />
    قد نشارك معلوماتك مع مزودي خدمات خارجيين يؤدون خدمات نيابةً عنا، مثل معالجة المدفوعات، وتحليل البيانات، وتسليم
    البريد الإلكتروني، وخدمات الاستضافة، وخدمة العملاء، والمساعدة في التسويق.
    <br /><br />

    ب. المتطلبات القانونية:
    <br />
    قد نُفصح عن معلوماتك إذا كان القانون يستوجب ذلك أو استجابةً لطلبات مشروعة من السلطات العامة (مثل محكمة أو جهة
    حكومية).
    <br /><br />

    ج. عمليات نقل الأعمال:
    <br />
    في حالة الاندماج أو الاستحواذ أو بيع الأصول، قد يتم نقل معلوماتك. وسنُخطرك قبل نقل معلوماتك الشخصية وخضوعها لسياسة
    خصوصية مختلفة.
    <br /><br />

    <b>4. خياراتك</b>
    <br />
    لديك الحقوق التالية فيما يتعلق ببياناتك الشخصية:
    <br /><br />

    أ. الوصول والتحديث:
    <br />
    يمكنك الوصول إلى معلوماتك الشخصية وتحديثها عن طريق التواصل معنا على [أدخل معلومات الاتصال].
    <br /><br />

    ب. إلغاء الاشتراك:
    <br />
    يمكنك إلغاء الاشتراك في تلقي الاتصالات التسويقية منا باتباع تعليمات إلغاء الاشتراك المُدرجة في رسائلنا الإلكترونية
    أو بالتواصل معنا مباشرةً.
    <br /><br />

    ج. حذف البيانات:
    <br />
    يمكنك طلب حذف معلوماتك الشخصية بالتواصل معنا على [أدخل معلومات الاتصال]. يُرجى ملاحظة أننا قد نحتفظ ببعض المعلومات
    كما يقتضي القانون أو لأغراض تجارية مشروعة.
    <br /><br />

    <b>5. الأمان</b>
    <br />
    نطبّق تدابير تقنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التعديل أو الإفصاح أو الإتلاف.
    <br /><br />

    <b>6. التغييرات على سياسة الخصوصية هذه</b>
    <br />
    قد نُحدّث سياسة الخصوصية هذه من وقت لآخر. وسنُخطرك بأي تغييرات عن طريق نشر سياسة الخصوصية الجديدة على موقعنا
    الإلكتروني. يُنصح بمراجعة سياسة الخصوصية هذه بشكل دوري للاطلاع على أي تغييرات.
    <br /><br />

    <b>7. تواصل معنا</b>
    <br />
    إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يُرجى التواصل معنا على:
    <br /><br />

    البرشامة
    <br />
    البريد الإلكتروني:
    <a href="mailto:support@el-bershama.com">support@el-bershama.com</a>
    <br />
    الهاتف: <a href="tel:+201013703712">+201013703712</a>
  </p>
</div>